import Vue from 'vue'
import {USER_LOGIN, USER_LOGOUT, USER_REGISTER} from '../mutation-types'
import userApi from '../../api/user'

export default {
    state: JSON.parse(sessionStorage.getItem('user')) || {},
    mutations: {
        [USER_LOGIN](state, user) {
            sessionStorage.setItem('user', JSON.stringify(user));
            Object.assign(state, user);
        },
        [USER_LOGOUT](state) {
            sessionStorage.removeItem('user');
            Object.keys(state).forEach(k => Vue.delete(state, k))
        },
        [USER_REGISTER](state, user) {
            sessionStorage.setItem('user', JSON.stringify(user));
            Object.assign(state, user);
        }
    },
    actions: {
        [USER_LOGIN]({commit}, user) {
            return new Promise((resolve, reject) => {
                userApi.login(user, (userInfo) => {
                    commit(USER_LOGIN, userInfo);
                    resolve();
                }, (errorCode) => {
                    reject(errorCode);
                })
            });
        },
        [USER_REGISTER]({commit}, user) {
            return new Promise((resolve, reject) => {
                userApi.register(user, (userInfo) => {
                    commit(USER_REGISTER, userInfo);
                    resolve();
                }, (errorCode) => {
                    reject(errorCode);
                })
            });
        },
        [USER_LOGOUT]({commit}) {
            commit(USER_LOGOUT)
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js